;
( function( $, window, document, undefined )
{
    'use strict';

    var ContactManager = function( options )
    {
        this.init();
    };

    ContactManager.prototype = {

        init : function()
        {
            var that = this;

            $( '.contact-manager' ).click( function( e )
            {
                if( $( this ).hasClass( 'my-contacts' ) )
                {
                    return;
                }

                e && e.preventDefault();

                if( $( this ).hasClass( 'logged-out' ) )
                {
                    event_tracking.trackSignIn( this, 'add friend button' );

                    var loginLink        = $( '#login-link a' ).attr( 'href' );
                    window.location.href = loginLink;

                    return;
                }

                if( !window._currentUserId || this.loading )
                {
                    return;
                }

                this.loading = true;
                this.action  = $( this ).hasClass( 'add-contact' ) ? 'addContact' : 'removeContact';
                var t        = this;

                $( this ).addClass( 'loading' );

                that.user( window._currentUserId )[ this.action ]( $( this ).data( 'id' ) ).done( function()
                {

                    if( t.action == 'addContact' )
                    {
                        $( t ).removeClass( 'add-contact' ).addClass( 'remove-contact' ).text( $( t ).data( 'remove-text' ) );
                    }
                    else
                    {
                        $( t ).removeClass( 'remove-contact' ).addClass( 'add-contact' ).text( $( t ).data( 'add-text' ) );
                    }

                } ).fail( function()
                {

                } ).always( function()
                {
                    $( t ).removeClass( 'loading' )[ 0 ].loading = false;
                } );
            } );
        },

        user : function( id )
        {
            this.userId = id;
            return this;
        },

        addContact : function( id )
        {
            return this._action( this.userId, id, 'add' );
        },

        removeContact : function( id )
        {
            return this._action( this.userId, id, 'remove' );
        },

        _action : function( user, contact, action )
        {
            return $.ajax( {
                type     : 'POST',
                dataType : 'json',
                url      : '/restapi/vc/users/id/' + user + '/addressbook/contacts/friends/' + action + '?xslt=json.xsl&contacts.user=id/' + contact
            } );
        }

    };

    $.fn.ContactManager = function( options )
    {
        var args     = Array.prototype.slice.call( arguments, 1 )
          , $item    = $( this )
          , instance = $item.data( 'ContactManager' );

        if( !instance )
        {
            instance = new ContactManager( this, options );
            $item.data( 'ContactManager', instance );
        }

        if( typeof options === 'string' )
        {
            instance[ options ].apply( instance, args );
        }

        return this;
    };

} )( jQuery, window, document );